import { useBusinessDetailsQuery } from './queries/useBusinessDetailsQuery'
import { useIndustriesQuery } from './queries/useIndustriesQuery'

export const useBusinessDetailsData = (isEnabled = true) => {
  const {
    data: businessDetails,
    isFetching: isFetchingBusinessDetails,
    isError: isErrorFetchingBusinessDetails,
  } = useBusinessDetailsQuery(isEnabled)

  const {
    data: industryOptions,
    isFetching: isFetchingIndustries,
    isError: isErrorFetchingIndustries,
  } = useIndustriesQuery(isEnabled)

  return {
    businessDetails,
    industryOptions,
    isLoadingBusinessDetailsData: isFetchingBusinessDetails || isFetchingIndustries,
    isErrorLoadingBusinessDetailsData: isErrorFetchingBusinessDetails || isErrorFetchingIndustries,
  }
}
